const COMMENTS = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20profile%20photo%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20warm%20background%2C%20clean%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
    text: '自从发现白云视频，追剧再也不用到处找资源了！西瓜视频同类型的免费看剧体验，而且真的不卡顿，画质也很清晰。已经推荐给身边所有朋友了！',
    time: '3天前',
  },
  {
    name: '电影爱好者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20profile%20photo%2C%20stylish%20glasses%2C%20confident%20expression%2C%20simple%20warm%20background%2C%20clean%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
    text: '没想到免费视频平台能做到这个水平！白云视频的片库太全了，热门电影电视剧基本都有，更新速度也快。高清不卡顿真的不是吹的，比很多收费的视频平台体验都好。',
    time: '5天前',
  },
  {
    name: '家庭观影小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20profile%20photo%2C%20warm%20smile%2C%20natural%20look%2C%20simple%20warm%20background%2C%20clean%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    text: '全家人都在用白云视频看剧！电视剧资源特别丰富，而且分类很清晰，老人小孩都能轻松找到想看的内容。免费影视还能不卡顿，真的太良心了～',
    time: '1周前',
  },
  {
    name: '深夜追剧人老陈',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%20profile%20photo%2C%20relaxed%20expression%2C%20casual%20style%2C%20simple%20warm%20background%2C%20clean%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    text: '作为一个资深追剧党，白云视频和西瓜视频免费体验真的没差多少。最重要的是完全免费！在线看剧流畅不卡顿，晚上高峰期也能稳定播放，这个必须给好评。',
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          影迷热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来自真实用户的观影反馈
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {COMMENTS.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl p-5 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">
                    {c.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{c.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="flex items-center gap-0.5 mt-3 text-accent-500">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}